module.exports = __webpack_public_path__ + "img/coupe.8940627e.png";